import React from "react";
import "./styles.less";

export const Title = (props) => {
  const { children, title } = props;
  return (
    <div className="authing-new-title-wrapper">
      <h3 className="title">{title}</h3>
      {children && <div className="description">{children}</div>}
    </div>
  );
};
